import { NgModule } from '@angular/core';
import { ROUTES } from '@angular/router';
import { CameraModalComponent } from './camera-modal/camera-modal.component';

const uiModals = [
  {
    data: {
      loadModal: () => Promise.resolve(CameraModalComponent),
    },
    loadChildren: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
    path: 'hack_path_not_used',
  },
];

@NgModule({
  providers: [
    // Modals have nothing to do with routes, but this is a hack to make the
    // CLI code splitting and ngc lazy module analysis and compilation work,
    // pending proper fix in https://github.com/angular/angular-cli/issues/4541
    {
      provide: ROUTES,
      useValue: uiModals,
      multi: true,
    },
  ],
})
export class UiModalsModule {}
